import React from 'react'
import { NavLink } from 'react-router-dom'

/**
 * Horizontal sub-tab bar for the Universe section.
 *
 * Universe is the gateway to reference entities (Companies, Scenarios) that
 * are normally reached by clickthrough from a workspace. When users do want
 * to browse them directly, this sub-tab lives in the page header of any
 * `/universe/*` route so the section context is always clear.
 */
export default function UniverseTabs() {
  return (
    <nav
      className="universe-tabs"
      aria-label="Universe sections"
      style={{
        display: 'flex',
        gap: 4,
        margin: '12px 0 16px',
        borderBottom: '1px solid var(--border)',
        overflowX: 'auto',
      }}
    >
      <UniverseTabLink to="/universe" label="Overview" exact />
      <UniverseTabLink to="/universe/companies" label="Companies" matchPaths={['/companies']} />
      <UniverseTabLink to="/universe/scenarios" label="Scenarios" matchPaths={['/scenarios']} />
    </nav>
  )
}

function UniverseTabLink({
  to,
  label,
  exact,
  matchPaths,
}: {
  to: string
  label: string
  exact?: boolean
  matchPaths?: string[]
}) {
  return (
    <NavLink
      to={to}
      end={exact}
      className={({ isActive }) =>
        isActive || pathMatches(matchPaths) ? 'universe-tab universe-tab-active' : 'universe-tab'
      }
      style={({ isActive }) => ({
        padding: '8px 14px',
        fontSize: 13,
        fontWeight: 600,
        textDecoration: 'none',
        color: isActive || pathMatches(matchPaths) ? 'var(--text)' : 'var(--muted)',
        borderBottom: '2px solid transparent',
        borderBottomColor:
          isActive || pathMatches(matchPaths) ? 'var(--accent)' : 'transparent',
        marginBottom: -1,
        whiteSpace: 'nowrap',
      })}
    >
      {label}
    </NavLink>
  )
}

function pathMatches(paths?: string[]) {
  if (!paths || paths.length === 0) return false
  if (typeof window === 'undefined') return false
  const cur = window.location.pathname
  return paths.some((p) => cur === p || cur.startsWith(p + '/'))
}
